import './ProfileCard.css';
import { useEffect, useState } from 'react';
import { refreshToken, getUserProfile } from '../../utils/api';
import { Routes, Route, Link, Outlet, useNavigate } from 'react-router-dom';
import { FaClock, FaUser, FaEdit, FaListOl, FaCreditCard, FaRegEnvelopeOpen, FaUsers, FaRegCalendarAlt, FaRegEdit, FaRegCalendarCheck, FaRegCalendarTimes, FaRegCircle, FaRegThumbsUp, FaRegComment, FaPlus, FaUserCircle } from "react-icons/fa";
import Spinner from '../../components/layout/Spinner';
import { isBuyer, isSeller } from '../../services/auth.service';
import { refresh } from '../../services/auth.service';

const ProfileCard = ({activeRole}) => {
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    //alert(isSeller());
    //alert(isBuyer());
    // based on users current role as buyer or seller
    async function loadUserProfile() {
      let response = await getUserProfile();

      if (response.success) {
        let data = response.data;

        setUser(response.data);
        setLoading(false);
        setSuccess(true);
      }

      else if (response.status === 403) {
        await refresh();
        let response = await getUserProfile();

        if (response.success) {
          setUser(response.data);
          setLoading(false);
          setSuccess(true);
        }
      }

      else {
        setLoading(false);
      }

      setLoading(false);
    }

    loadUserProfile();
  }, []);

  return (
    <div className="profilecard">
      {loading && (
        <Spinner />
      )}

      

      {loading === false && success == true && (
        <>
          <div className='profilecard__image'>
            <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + user.company_logo} />
          </div>

          {loading === false && user.first_name && user.first_name.length > 0 && (
            <div className='profilecard__name'>
              <span>{user.first_name}{' '}{user.last_name}</span>
            </div>
          )}

          {loading === false && user.first_name && user.first_name.length === 0 && (
            <div className='center profilecard__edit-link'>
              <Link to='/dashboard/profile'><i>Edit your profile</i></Link>
            </div>
          )}

          {loading === false && (user.first_name == null || user.first_name.length == 0 && (
            <div className='center'>
              <Link to={'/account/profile'} className='center' style={{ display: 'block' }}>
                <span className='link' style={{ color: 'red', fontWeight: 'bold' }}>Fill out your name</span>
              </Link>
            </div>
          ))}

          {user.job_title && user.job_title.length > 0 && (
          <div className='text-sm text-gray-500'>
            {user.job_title} at {user.company_name}
          </div>
          )}

          {isBuyer() && !user.company_id && (
            <div className='mt-2 px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm'>
              <Link to='/account/company'>
              ⚠️ Complete your account
              </Link>
            </div>
          )}

          {isSeller() && activeRole == 'seller' && (
            <div className='mt-2 text-sm text-purple-600 hover:text-purple-500 font-medium'>
              <Link className='' to={`/company/${user.company_id}`}>View company profile</Link>
            </div>
          )}

          {isBuyer() && activeRole == 'buyer' && (
            <>
              {user.slug && user.slug.length > 0 && (
              <div className='mt-2 text-sm text-purple-600 hover:text-purple-500 font-medium'>
                <Link className='' to={`/account/profile`}>View professional profile</Link>
              </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  )
}

export default ProfileCard;